import { isDev } from './general';

// Logging middleware
export function loggingMiddleware(contextName) {
  return reducer => {
    return (state, action) => {
      const prevState = state; // Capture previous state
      const nextState = reducer(state, action); // Get new state

      if (isDev) {
        // Log the action and state changes
        console.groupCollapsed(`%c ${contextName} action - ${action.type}:`, 'background: #89fb4c; color: #093793');
        console.log('Action:', action);
        console.log('Previous State:', prevState);
        console.log('Next State:', nextState);
        console.groupEnd();
      }

      // Return the new state
      return nextState;
    };
  };
}